export const GET_THERMOBOX_INFO = 'thermoboxes-modal/GET_THERMOBOX_INFO';
export const getThermoboxInfoAction = payload => ({
	type: GET_THERMOBOX_INFO,
	payload,
});

export const SET_THERMOBOX_INFO = 'thermoboxes-modal/SET_THERMOBOX_INFO';
export const setThermoboxInfoAction = payload => ({
	type: SET_THERMOBOX_INFO,
	payload,
});

export const SET_IS_THERMOBOX_INFO_LOADING = 'thermoboxes-modal/SET_IS_THERMOBOX_INFO_LOADING';
export const setIsThermoboxInfoLoadingAction = payload => ({
	type: SET_IS_THERMOBOX_INFO_LOADING,
	payload,
});

export const CREATE_THERMOBOX = 'thermoboxes-modal/CREATE_THERMOBOX';
export const createThermoboxAction = payload => ({
	type: CREATE_THERMOBOX,
	payload,
});

export const SET_IS_THERMOBOX_CREATING = 'thermoboxes-modal/SET_IS_THERMOBOX_CREATING';
export const setIsThermoboxCreatingAction = payload => ({
	type: SET_IS_THERMOBOX_CREATING,
	payload,
});

export const UPDATE_THERMOBOX = 'thermoboxes-modal/UPDATE_THERMOBOX';
export const updateThermoboxAction = payload => ({
	type: UPDATE_THERMOBOX,
	payload,
});

export const SET_IS_THERMOBOX_UPDATING = 'thermoboxes-modal/SET_IS_THERMOBOX_UPDATING';
export const setIsThermoboxUpdatingAction = payload => ({
	type: SET_IS_THERMOBOX_UPDATING,
	payload,
});

export const DELETE_THERMOBOX = 'thermoboxes-modal/DELETE_THERMOBOX';
export const deleteThermoboxAction = payload => ({
	type: DELETE_THERMOBOX,
	payload,
});

export const SET_IS_THERMOBOX_DELETING = 'thermoboxes-modal/SET_IS_THERMOBOX_DELETING';
export const setIsThermoboxDeletingAction = payload => ({
	type: SET_IS_THERMOBOX_DELETING,
	payload,
});

export const GET_PARTNERS = 'thermoboxes-modal/GET_PARTNERS';
export const getPartnersAction = () => ({
	type: GET_PARTNERS,
});

export const SET_PARTNERS = 'thermoboxes-modal/SET_PARTNERS';
export const setPartnersAction = payload => ({
	type: SET_PARTNERS,
	payload,
});

export const SET_IS_PARTNERS_LOADING = 'thermoboxes-modal/SET_IS_PARTNERS_LOADING';
export const setIsPartnersLoadingAction = payload => ({
	type: SET_IS_PARTNERS_LOADING,
	payload,
});

export const RESET_STATE = 'thermoboxes-modal/RESET_STATE';
export const resetThermoboxModalAction = () => ({
	type: RESET_STATE,
});
